module.exports = __webpack_public_path__ + "static/media/21ECLAC52.a5f9ec79.jpg";